import React, {Component} from "react";  import config from 'react-global-configuration';
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
var ddefault = new Date();
var ddefault1 = formatDate(ddefault);

class Reports extends Component{
    constructor(props) {
        super(props);
        this.state = {

            loading:false,
            sel_req_no:'',
            sel_call_id:'',
            sel_tick_no:'',
            sel_status:'',
            sel_state:'',
            sel_city:'',
            sel_date: ddefault1,
            req_no_lists:[],
            cl_id_lists:[],
            tc_no_lists:[],
            status_lists:[],
            states_lists:[],
            cities_lists:[],


        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.get_req_no_lists('','');
        this.showReports()
    }

    get_req_no_lists(r_no, tick_no){
        var req_no = [];
        var ticket_no = [];
        if(r_no!='') {
            req_no.push(r_no)
        }
        if(ticket_no!='') {
            ticket_no.push(tick_no)
        }
        axios.post(config.get('API_URL')+'/anycardemi/get-req-no-list/',{
                request_no: req_no,
                ticket_no: ticket_no
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {

            console.log(response);
            if(Array.isArray(response.data.data) && response.data.data.length) {
                this.setState({
                    req_no_lists: response.data.data.request_no,
                    cl_id_lists: response.data.data.call_id,
                    tc_no_lists: response.data.data.ticket_no,
                    status_lists: response.data.data.status,
                    states_lists: response.data.data.states,
                    cities_lists: response.data.data.cities
                })
            }
        });
    }
    submitDta(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if ($.fn.DataTable.isDataTable('#TasksReportsTable')) {
            $('#TasksReportsTable').DataTable().destroy();
        }

        var postData = {
            user_email: decoded.email,
            request_no: this.state.sel_req_no,
            date: this.state.sel_date,
            call_id: this.state.sel_call_id,
            ticket_no: this.state.sel_tick_no,
            ticket_status: this.state.sel_status,
            city: this.state.sel_state,
            state: this.state.sel_city,
        };
        // $('#RequestTable').html('');
        var req = $('#TasksReportsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/get-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { console.log("gxccbcvbcvcv");
                        console.log(json);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"request_no"},
                    {"data":"ticket_no"},
                    {"data":"call_id"},
                    {"data":"date"},
                    {"data":"city"},
                    {"data":"state"},
                    {"data":"ticket_status"},
                ],

            });
    }
    showReports(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if ($.fn.DataTable.isDataTable('#TasksReportsTable')) {
            $('#TasksReportsTable').DataTable().destroy();
        }
        var postData = {
            user_email: decoded.email,
            request_no: '',
            date: this.state.sel_date,
            call_id: '',
            ticket_no: '',
            ticket_status: '',
            city: '',
            state: '',
        };
        // $('#RequestTable').html('');
        var req = $('#TasksReportsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": false,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/anycardemi/get-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { console.log("gxccbcvbcvcv");
                        console.log(json);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"request_no"},
                    {"data":"ticket_no"},
                    {"data":"call_id"},
                    {"data":"date"},
                    {"data":"city"},
                    {"data":"state"},
                    {"data":"ticket_status"},

                ],

            });
    }
    changeReqNo(e){
        this.setState({
            sel_req_no: e.target.value
        });
        this.get_req_no_lists(e.target.value)
    }

    changeDate_sel = date => {
        var date1 = this.formatDate(date);

        this.setState({
            sel_date: date1
        });
    };
    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    changeCallID(e){
        this.setState({
            sel_call_id: e.target.value
        })

    }
    changeTicketNo(e){
        this.setState({
            sel_tick_no: e.target.value
        });
        this.get_req_no_lists(this.state.sel_req_no, e.target.value)
    }
    changeStatus(e){
        this.setState({
            sel_status: e.target.value
        })

    }
    changeState(e){
        this.setState({
            sel_state: e.target.value
        })
    }
    changeCity(e){
        this.setState({
            sel_city: e.target.value
        })
    }
    render() {
        let req_no_list = this.state.req_no_lists.map((req,index) => {
            return (
                <option value={req.request_no} key={index+1}>{req.request_no}</option>
            )
        });
        let cl_list = this.state.cl_id_lists.map((req,index) => {
            return (
                <option value={req.call_id} key={index+1}>{req.call_id}</option>
            )
        });
        let tc_list = this.state.tc_no_lists.map((req,index) => {
            return (
                <option value={req.fd_ticket_number} key={index+1}>{req.fd_ticket_number}</option>
            )
        });
        let st_list = this.state.status_lists.map((req,index) => {
            return (
                <option value={req.ticket_status} key={index+1}>{req.ticket_status}</option>
            )
        });
        let sta_list = this.state.states_lists.map((req,index) => {
            return (
                <option value={req.state} key={index+1}>{req.state}</option>
            )
        });

        let ct_list = this.state.cities_lists.map((req,index) => {
            return (
                <option value={req.city} key={index+1}>{req.city}</option>
            )
        });


        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="">
                            <div className="">
                                <div className="header"><h4 className="titleAnyCart nomargin">Filter</h4><p
                                    className="categoryEmi">Select your filters</p></div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_req_no}
                                                onChange={this.changeReqNo.bind(this)}>
                                            <option value="">Request No</option>
                                            {req_no_list}

                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <DatePicker
                                            dateFormat="yyyy-MM-dd"
                                            selected={Date.parse(this.state.sel_date)}
                                            onChange={this.changeDate_sel}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_call_id}
                                                onChange={this.changeCallID.bind(this)}>
                                            <option value="">Call ID</option>
                                            {cl_list}

                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_tick_no}
                                                onChange={this.changeTicketNo.bind(this)}>
                                            <option value="">Ticket No</option>
                                            {tc_list}

                                        </select>
                                    </div>
                                </div>
                                <div className="gap_ver"></div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_status}
                                                onChange={this.changeStatus.bind(this)}>
                                            <option value="">Status</option>
                                            {st_list}

                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_state}
                                                onChange={this.changeState.bind(this)}>
                                            <option value="">State</option>
                                            {sta_list}

                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <select name="req_no" className="form-control chainList" value={this.state.sel_city}
                                                onChange={this.changeCity.bind(this)}>
                                            <option value="">City</option>
                                            {ct_list}
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2 pull-right">
                                        <button type="button" className="btn btn-primary" onClick={this.submitDta.bind(this)}>Submit</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="ro-sep"></div>
                                </div>
                                <div className="">
                                    <div className="content-tdetails-table table-full-width table-responsive">
                                        <table id="TasksReportsTable" className="table table-striped table-hover">
                                            <thead>

                                                <tr>
                                                    <th>Request No.</th>
                                                    <th>Ticket No</th>
                                                    <th>Call ID</th>
                                                    <th>Date</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                    <th>Status</th>
                                                </tr>

                                            </thead>
                                            <tbody>

                                            </tbody>

                                        </table>
                                        <div className="gap_ver"></div>
                                        <div className="col-md-3 pull-right">
                                            {/*<button width="100%" type="button" className="btn btn-secondary">Cancel</button> &nbsp;*/}
                                            {/*<button width="100%" type="button" className="btn btn-primary" onClick={this.createUTID.bind(this)}>Create UTID</button>*/}
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="gap_ver"></div>
                                    </div>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Reports